<template>
  <div id="stops">
    <h1>{{$t('map.transport.stops.title')}}</h1>
    <p>{{$t('map.transport.stops.directions')}}</p>
    <a
      v-if="signedURL"
      :href="signedURL"
      class="download-btn"
      download
      target="_blank"
    >{{$t('map.transport.schedules.download')}}</a>
    <!-- File input - csv -->
    <div class="input-container">
      <FileUploader
        :placeholder="$t('map.transport.stops.filePH')"
        :type="'.csv'"
        :label="$t('map.transport.stops.browse')"
        :fileUrl="fileUrl"
        @setFile="setFile"
      />
      <div class="error-msg">
        <span v-if="$v.file.$error">{{$t("map.transport.stops.errors.fileRequired")}}</span>
      </div>
    </div>
    <!-- Drag & drop file -->
    <!-- <div
    v-if="!file"
    class="drop-container"
    v-on:dragover.prevent
    v-on:drop.prevent="dropGetFile">
      {{$t('map.transport.stops.dropFile')}}
    </div>-->
    <div class="uploadInfo">{{uploadStatus}}</div>
    <button
      type="button"
      class="btn btn-dark control publish-btn"
      :disabled="isLoading"
      @click="validateForm"
    >{{$t('map.transport.stops.upload')}}</button>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import S3_Handler from "@/lib/api/s3_handler";
import STOPS_API from "@/lib/api/Stops.js";
const s3 = new S3_Handler();
const api = new STOPS_API();
const FileUploader = () => import("@/components/FileUploader");

export default {
  components: {
    FileUploader,
  },
  data: function () {
    return {
      isLoading: false,
      file: null,
      fileUrl: null,
      uploadStatus: "",
      signedURL: null,
    };
  },
  validations: {
    file: {
      required,
    },
  },
  beforeMount: async function () {
    await this.getStops();
    await this.getFile();
  },
  methods: {
    async getFile() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const response = await api.getStopsFiles();
        this.fileUrl = response[0].source;
        const urlResp = s3.getSignedUrl(this.fileUrl);
        this.signedURL = urlResp;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    getStops: async function () {
      this.$store.commit("global/SET_LOADING", true);

      try {
        const response = await api.getStops();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    setFile: function (file) {
      this.file = file;
      if (this.file) {
        this.uploadStatus = "Ready to upload";
      } else {
        this.uploadStatus = "";
      }
    },
    dropGetFile: function (event) {
      const file = event.dataTransfer.files[0];
      this.file = file;
      this.fileUrl = file.name;
      this.uploadStatus = "Ready to upload";
    },
    validateForm: async function () {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      await this.uploadFile();
    },
    uploadFile: async function () {
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      this.uploadStatus = "Uploading...";
      const s3 = new S3_Handler();
      const api = new STOPS_API();
      try {
        const timestamp = Date.now();
        const fileResp = await s3.uploadFile(
          `${timestamp}_transportation_stops.csv`,
          this.file
        );
        const { Bucket, Key } = fileResp;
        // await api.postStops(fileResp.Bucket, fileResp.Key);
        await api.postStopsFile(fileResp.Location, "prod_stops");
        await api.postStops(Bucket, Key);

        // this.uploadStatus = response;
        this.uploadStatus = "File uploaded";
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
        this.file = null;
        this.fileUrl = null;
        this.$v.$reset();
        await this.getStops();
      } catch (error) {
        this.uploadStatus = error;
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;
        console.log(error);

        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#stops {
  background-color: $white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 4rem;

  .input-container {
    width: 40%;
  }

  .error-msg {
    color: $warn_red;
    font-size: 14px;
  }
  .download-btn {
    background-color: $black;
    color: $white;
    border-radius: 0;
    padding: 0.5rem 2rem;
    align-self: flex-end;
  }
  .drop-container,
  .uploadInfo {
    width: 80%;
    height: 6rem;
    background-color: $w_2;
    border: 1px solid $wg_2;
    align-self: center;
    margin: 3rem 0;
    padding: 1rem;
  }
  .drop-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .uploadInfo {
    overflow-y: scroll;
  }

  .publish-btn {
    align-self: flex-end;
    background: #000;
    border-radius: 0px;
    padding: 0.5rem 1rem;
  }
}
</style>